module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Github-6f1323aac0441c65ca24af678f785c99fffb8919fe55aac1f225ee843bb6a049.svg";